export default __webpack_public_path__ + "static/media/petgramImg_5.e026dd6a.png";